export default "__VITE_ASSET__7230a898__"